import { makeLMStyles } from "@launchmetrics/lm-ui";


export const useStyles = makeLMStyles(() => ({
	header: {
		triggerWrapper: {
			cursor: 'pointer',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: "48px",
			width: "48px",
			borderRadius: "4px",
			hover: {
				":hover": {
					backgroundColor: '#1EE9A51A'
				}
			}
		},
		triggerOpened: {
			background: "#1EE9A533"
		},
		fileIcon: {
			color: 'icon.primary'
		},
		errorWrapper: {
		},
		loader: {
			position: 'absolute',
			strokeWidth: '2px',
			stroke: "var(--border-neutral-default, #CFCFD2)"
		}
	},
	downloadManager: {
		main: {
			borderRadius: "var(--border-radius-radius-4, 4px)",
			border: "1px solid var(--border-neutral-default, #CFCFD2)",
			background: "var(--Base-White, #FFF)",
			boxShadow: "0px 4px 11px 0px rgba(13, 22, 38, 0.10)",
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'start',
			width: '444px',
			minHeight: '200px',
			padding: "24px",
			marginTop: '-2px',
			zIndex: "20"
		},
		fileCard: {
			marginTop: '16px'
		},
		header: {
			title: {
				color: "var(--theme-ui-mapped-text-default, #252527)",
				fontWeight: 500,
				marginBottom: "8px"
			},
			description: {
				color: "var(--text-low, #5A5A60)",
				fontSize: "14px",
				fontWeight: "400",
				lineHeight: "20px",
				textAlign: "left",
				textDecorationSkipInk: "none"
			}
		},
		closeBtn: {
			display: 'flex',
			width: '100%',
			justifyContent: 'right',
			marginTop: '24px'
		}
	}
}));
